/**
 * 🔴🔴 US-AIV2-tourguide-0008 (@UC0362 · TG-INV-4 vế "đến đúng nơi" · N6 màn) — HỢP ĐỒNG NỘI DUNG MÀN.
 *
 * "Đến đúng nơi" ≠ "mở được một màn". Ca gốc (K23): thẻ "cấu hình vừa đổi" trỏ màn Hoạt động — màn dựng từ `activity-feed.service.ts`, KHÔNG
 * đọc `audit_log` ⇒ thay đổi thẻ vừa nói không hiện ở nơi nút dẫn tới; người dùng tưởng đã xem rồi. Một màn sai mà không báo lỗi là ngõ cụt khó
 * thấy nhất.
 *
 * Ba lớp, một chốt:
 *  1. **Màn hiện gì** — `AI_SCREEN_CONTENT_BY_ROUTE`: route Sổ (đúng chuỗi `screen`/`guiScreen`) ⇒ tập nội dung (từ vựng ĐÓNG `AI_SCREEN_CONTENTS`).
 *     Nghĩa của một mục: màn HIỆN nó, hoặc mở được bằng MỘT chạm vào một dòng/mục CỦA CHÍNH màn đó (vd tab Thành viên ⇒ bấm một người ⇒ "Xoá
 *     thành viên"). Đo trên app thật (`apps/mobile`, khảo sát 05/10 — README `_runs/US-AIV2-tourguide/0008` §2), KHÔNG theo tên route.
 *  2. **Điều khẳng định** — trang đích khai `screenShows` (điều câu/nhãn của trang hứa người dùng sẽ thấy); thẻ có nút tới trang redirect khai
 *     `cta.shows`; câu lỗi có nút mở màn khai `shows` (api, `AI_FAILURE_WITH_BUTTON`).
 *  3. **Chốt** — điều khẳng định ⊆ nội dung màn (`aiScreenClaimGaps`) ở domain (`screen-content.invariants.spec.ts`), ở cửa nút lối rẽ
 *     (`GuideButtonGate.detourButtons`) và ở máy đo `0001` (ô `SCREEN` — `guide-audit.mjs`). Lệch ⇒ ĐỎ, nêu tên.
 *
 * Lệch ĐÃ BIẾT (app chưa có màn cho việc đó) không được giấu bằng cách khai ít đi: trang khai ĐÚNG điều câu của nó hứa, và nằm trong sổ nợ
 * `AI_SCREEN_CLAIM_DEBTS` (chỉ co lại) — máy đo in ô đó là "nợ hợp đồng màn", không xanh.
 */

/** Từ vựng ĐÓNG — mỗi mục một thứ người dùng thấy/làm được trên màn (hoặc một chạm từ một dòng của màn). Thêm mục = thêm một dòng ở đây. */
export const AI_SCREEN_CONTENTS = [
  // ── danh sách nhóm ──
  "group_list", // danh sách nhóm của tôi
  "my_join_request", // nhóm tôi đang xin vào (thẻ "Đang chờ duyệt" ⇒ "Huỷ yêu cầu")
  // ── màn nhóm (ba tab + thanh nút dưới theo tab) ──
  "group_activity_feed", // nhật ký hoạt động của nhóm (tab Hoạt động)
  "group_balance", // thẻ số dư của nhóm
  "expense_record", // "Chi quỹ": số tiền · ngày · tên · 1 tệp đính kèm — KHÔNG có ô người ứng bù. Thành viên thường: GỬI YÊU CẦU CHI chờ duyệt (QĐ 12/10/2026)
  "self_contribute", // "Nộp quỹ": báo đã chuyển / ghi nhận nộp
  "transaction_correct", // bấm một dòng ⇒ "Cập nhật" (sửa số tiền = bút toán đảo). Nút "Hoàn lại khoản chi" TẠM ẨN (QĐ người dùng 12/10/2026)
  "transaction_label", // bấm một dòng ⇒ ô "Tiêu đề" (nhãn giao dịch)
  "member_list", // danh sách thành viên (tab Thành viên)
  "member_add", // thêm người (bảng chọn cách thêm / nhập tên bé)
  "member_invite", // "Mời vào nhóm"
  "member_remove", // bấm một người ⇒ "Xóa thành viên"
  "member_status_link", // bấm một người ⇒ "Gửi tình hình đóng quỹ"
  "member_rename", // bấm một người ⇒ "Sửa tên hiển thị"
  "member_birth_date", // nhóm phụ huynh: bấm một bé ⇒ chạm ô "Ngày sinh" (chủ nhóm / quản trị viên) — QĐ người dùng 18/10/2026
  "member_role_change", // bấm một người ⇒ "Đổi vai trò" (chỉ chủ nhóm; Quản trị viên / Thành viên) — QĐ người dùng 12/10/2026
  "member_scan", // "Nhập tự động" (quét ảnh danh sách): nhóm phụ huynh ở "Thêm học sinh"; nhóm thường ở "Thêm tên người chưa có app" (@UC0340, 18/10)
  "identity_link", // nối tài khoản với suất (thêm người đã có app / người đại diện)
  "collection_list", // thẻ đợt thu (tab Quản lý quỹ)
  "collection_create", // "Thêm yêu cầu đóng quỹ"
  "collection_close_reopen", // bấm một đợt ⇒ sửa ⇒ "Ngừng thu kỳ này" / "Kích hoạt lại"
  "collection_edit", // bấm một đợt ⇒ sửa tên/mô tả
  "collection_schedule", // bấm một đợt định kỳ ⇒ "Dừng cả quỹ thu" / "Kích hoạt lại quỹ thu"
  // ── cài đặt nhóm ──
  "group_info_edit", // ảnh · tên · mô tả nhóm
  "bank_account_setup", // "Thông tin ngân hàng quỹ nhóm" + "Mã QR chuyển khoản"
  "invite_link", // "Link mời & mã QR"
  "group_managers_entry", // "Danh sách quản trị viên"
  "public_link_entry", // "Link xem sổ công khai"
  "report_export", // "Tạo báo cáo thu chi" · "Xem bản đã xuất"
  "ownership_transfer", // "Chuyển quyền chủ nhóm"
  "leave_group", // "Rời nhóm"
  "group_archive_delete", // "Lưu trữ nhóm" · "Xóa nhóm"
  // ── màn riêng ──
  "group_managers", // danh sách quản trị viên (CHỈ ĐỌC)
  "public_link", // tạo/gửi/gỡ link xem sổ công khai
  "join_requests", // danh sách người xin vào nhóm ⇒ bấm một người ⇒ cho phép / từ chối
  "report_exports", // danh sách bản báo cáo đã xuất + tải về
  "payment_claim_review", // một lời báo đã chuyển: "Phê duyệt" / "Từ chối"
  "zalo_reminder", // "Nhắc qua Zalo": gửi riêng từng suất chưa đóng
  "due_transfer_info", // QR + số tài khoản + nội dung chuyển khoản của MỘT khoản
  "my_invitations", // danh sách lời mời của tôi (CHỈ ĐỌC — mở link trong email/tin nhắn để nhận)
  "notification_inbox", // hộp thông báo
  "profile_overview", // thông tin của tôi · mã QR · cài đặt
  "login_links", // "Tài khoản liên kết" (nối/gỡ cách đăng nhập)
  "profile_edit", // ảnh · tên của tôi
  "account_delete", // "Xoá tài khoản"
  "notification_settings", // bật/tắt thông báo theo loại
] as const;
export type AiScreenContent = (typeof AI_SCREEN_CONTENTS)[number];

type AiScreenRole = "owner" | "admin" | "treasurer" | "member";
const OWNER_ADMIN: readonly AiScreenRole[] = ["owner", "admin"];
const MANAGERS: readonly AiScreenRole[] = ["owner", "admin", "treasurer"];
const OWNER: readonly AiScreenRole[] = ["owner"];

/**
 * 🔴 review #1238 H1 — nội dung màn THEO VAI: mục chỉ vai nào THẤY/LÀM được (app gác bằng cờ server: `canManageMembers` = chủ nhóm + quản trị ·
 * `canInviteMembers` = chủ nhóm + quản trị · sửa đợt `_rolesThatCanEditCollection` = chủ nhóm + quản trị · nhắc / gửi tình hình / duyệt lời
 * báo = O/A/T · link công khai · chuyển quyền · lưu trữ/xoá = chủ nhóm — khảo sát 05/10). Vắng ⇒ MỌI vai. Chốt đòi: mọi vai được mở trang/thấy nút
 * đều thấy điều được khẳng định (`aiScreenClaimGaps` với `roles`).
 */
export const AI_SCREEN_CONTENT_ROLES: Readonly<Partial<Record<AiScreenContent, readonly AiScreenRole[]>>> = Object.freeze({
  member_add: OWNER_ADMIN,
  member_invite: OWNER_ADMIN,
  member_remove: OWNER_ADMIN,
  member_rename: OWNER_ADMIN,
  member_birth_date: OWNER_ADMIN,
  member_role_change: OWNER,
  member_scan: OWNER_ADMIN,
  identity_link: OWNER_ADMIN,
  collection_close_reopen: OWNER_ADMIN,
  collection_edit: OWNER_ADMIN,
  collection_schedule: OWNER_ADMIN,
  group_info_edit: OWNER_ADMIN,
  bank_account_setup: OWNER_ADMIN,
  invite_link: OWNER_ADMIN,
  join_requests: OWNER_ADMIN,
  // QĐ người dùng 12/10/2026 — thành viên thường NAY có nút "Chi quỹ" (gửi YÊU CẦU CHI, server ép chờ O/A/T duyệt) ⇒ mọi vai (vắng mục).
  collection_create: MANAGERS,
  member_status_link: MANAGERS,
  transaction_correct: MANAGERS,
  transaction_label: MANAGERS,
  payment_claim_review: MANAGERS,
  zalo_reminder: MANAGERS,
  // `report_export` · `report_exports` VẮNG = mọi vai (GUIDE-SCREEN-TRUTH 15/10): QĐ PO 30/09 (US-E23.F1-0867) mở mục «Dữ liệu & Xuất dữ liệu»
  // (cờ `canExportFinanceReport`) + «Xem bản đã xuất» (bản của chính mình) cho thành viên thường — bảng cũ còn ghi O/A/T.
  public_link_entry: OWNER,
  public_link: OWNER,
  ownership_transfer: OWNER,
  group_archive_delete: OWNER,
});

/** Màn nhóm mặc định (tab Hoạt động) — thanh nút dưới: "Chi quỹ" (O/A/T ghi; thành viên gửi yêu cầu — QĐ 12/10/2026) · "Nộp quỹ". */
const GROUP_HOME: readonly AiScreenContent[] = ["group_activity_feed", "group_balance", "expense_record", "self_contribute"];
const MEMBERS_TAB: readonly AiScreenContent[] = [
  "member_list",
  "member_add",
  "member_invite",
  "member_remove",
  "member_status_link",
  "member_rename",
  "member_birth_date",
  "member_role_change",
  "member_scan",
  "identity_link",
];

/**
 * Route Sổ ⇒ màn hiện gì. KHOÁ = chuỗi route NGUYÊN VĂN như Sổ khai (`/groups/:groupId/settings`). Lưới domain đòi: mọi route đích có mục ·
 * không mục thừa. Nguồn đo: khảo sát mã màn `apps/mobile` 05/10 (README 0008 §2) — đổi màn ở app ⇒ sửa đúng dòng ở đây.
 */
export const AI_SCREEN_CONTENT_BY_ROUTE: Readonly<Record<string, readonly AiScreenContent[]>> = Object.freeze({
  "/groups": ["group_list", "my_join_request"],
  "/groups/:groupId": GROUP_HOME,
  "/groups/:groupId/activities": [...GROUP_HOME, "transaction_correct", "transaction_label"],
  "/groups/:groupId/members": MEMBERS_TAB,
  "/groups/:groupId/add-member": MEMBERS_TAB,
  "/groups/:groupId/collections": ["group_balance", "collection_list", "collection_create", "collection_close_reopen", "collection_edit", "collection_schedule"],
  "/groups/:groupId/settings": [
    "group_info_edit",
    "bank_account_setup",
    "invite_link",
    "group_managers_entry",
    "public_link_entry",
    "report_export",
    "ownership_transfer",
    "leave_group",
    "group_archive_delete",
  ],
  // `/groups/:groupId/managers` GỠ (QĐ người dùng 12/10/2026): trang Sổ duy nhất trỏ nó (`GRP-MEMBER-ROLE`) nay trỏ màn Thành viên — nơi có
  // nút «Đổi vai trò». Lưới "bảng không thừa route" đòi gỡ.
  "/groups/:groupId/public-link": ["public_link"],
  "/groups/:groupId/join-requests": ["join_requests"],
  "/groups/:groupId/payment-claims/:memberDueId": ["payment_claim_review"],
  "/groups/:groupId/collections/:collectionId/remind-zalo": ["zalo_reminder"],
  "/groups/:groupId/bank-qr/:memberDueId": ["due_transfer_info"],
  "/my-invitations": ["my_invitations"],
  "/notifications": ["notification_inbox"],
  "/profile": ["profile_overview", "login_links"],
  "/profile/edit": ["profile_edit", "login_links", "account_delete"],
  "/profile/notifications": ["notification_settings"],
});

/**
 * SỔ NỢ — trang mà điều câu của nó hứa CHƯA màn nào của app có. Chỉ CO LẠI (lưới đòi mỗi mục còn lệch thật; trần 0 — QĐ PO 05/10 «sửa câu cho đúng
 * ngay»: INVITE-ACCEPT · GRP-MEMBER-ROLE · EXP-VOTE đã nói đúng app hôm nay, bảng PO 0008 dòng 14–16). Máy đo in ô của
 * các trang này là "nợ hợp đồng màn" (chưa xanh), không giấu. Sửa = app có màn (rồi gỡ dòng) hoặc PO đổi câu/đích của trang.
 */
export const AI_SCREEN_CLAIM_DEBTS: Readonly<Record<string, string>> = Object.freeze({});

/** Route MẪU mà một trang mở: `screen` (redirect) hoặc `guiScreen` (trang đọc/ghi). */
export function aiScreenRouteOfPage(page: { readonly screen?: string | undefined; readonly guiScreen?: string | undefined }): string | undefined {
  return page.screen ?? page.guiScreen;
}

/** Một lời khẳng định "bấm nút này bạn sẽ thấy X" — để chốt. */
export interface AiScreenClaim {
  /** Ai khẳng định (để nêu tên khi đỏ) — vd `thẻ DUTY-NO-BANK-ACCOUNT → GRP-BANK-QR`. */
  readonly who: string;
  /** Trang đích (khoá sổ nợ). */
  readonly page: string;
  /** Route MẪU của màn đích. */
  readonly route: string;
  readonly shows: AiScreenContent | undefined;
  /** review #1238 H1 — vai THẤY nút/trang này (vắng ⇒ không đối vai). Mọi vai ở đây phải thấy `shows` trên màn. */
  readonly roles?: readonly string[];
}

export interface AiScreenClaimGap {
  readonly page: string;
  readonly why: string;
}

/** Chốt: mỗi lời khẳng định phải có `shows` VÀ `shows` ∈ nội dung màn của route. Trả danh sách lệch (rỗng = xanh). Hàm thuần. */
export function aiScreenClaimGaps(claims: readonly AiScreenClaim[]): AiScreenClaimGap[] {
  const out: AiScreenClaimGap[] = [];
  for (const c of claims) {
    const content = Object.prototype.hasOwnProperty.call(AI_SCREEN_CONTENT_BY_ROUTE, c.route) ? AI_SCREEN_CONTENT_BY_ROUTE[c.route] : undefined;
    if (content === undefined) out.push({ page: c.page, why: `${c.who}: màn ${c.route} chưa khai hiện gì` });
    else if (c.shows === undefined) out.push({ page: c.page, why: `${c.who}: không khai điều nó khẳng định ở màn ${c.route}` });
    else if (!content.includes(c.shows)) out.push({ page: c.page, why: `${c.who}: khẳng định «${c.shows}» nhưng màn ${c.route} chỉ hiện [${content.join(", ")}]` });
    else {
      const who = AI_SCREEN_CONTENT_ROLES[c.shows];
      const blind = who === undefined ? [] : (c.roles ?? []).filter((r) => !(who as readonly string[]).includes(r));
      if (blind.length > 0) out.push({ page: c.page, why: `${c.who}: vai ${blind.join(", ")} KHÔNG thấy «${c.shows}» ở màn ${c.route} (chỉ ${who!.join(", ")})` });
    }
  }
  return out;
}

/** Một lời khẳng định có đúng không (cửa nút lối rẽ hỏi cái này lúc dựng nút mở màn). */
export function aiScreenShows(route: string, shows: AiScreenContent | undefined, roles?: readonly string[]): boolean {
  return shows !== undefined && aiScreenClaimGaps([{ who: "", page: "", route, shows, ...(roles === undefined ? {} : { roles }) }]).length === 0;
}

const SEGMENT_PARAM = /^:[A-Za-z][A-Za-z0-9]*$/;
/** Giá trị tham số của route ĐÃ thế (id): không rỗng, không `:`, không `/`. */
const FILLED_VALUE = /^[^:/?#]+$/;

/**
 * Route ĐÃ THẾ THAM SỐ (`/groups/<uuid>/settings`) ⇒ route mẫu của bảng (`/groups/:groupId/settings`). Còn `:` (template chưa thế) / ngoài app
 * / không khớp mẫu nào ⇒ `undefined`. Khớp nhiều mẫu ⇒ mẫu có ÍT tham số nhất (đoạn chữ khớp nguyên văn thắng). Máy đo dùng để đối ô `SCREEN`.
 */
export function aiScreenTemplateOfRoute(route: string): string | undefined {
  if (!route.startsWith("/") || route.startsWith("//") || route.includes(":")) return undefined;
  const parts = route.split("/").slice(1);
  const hits = Object.keys(AI_SCREEN_CONTENT_BY_ROUTE).filter((tpl) => {
    const t = tpl.split("/").slice(1);
    return t.length === parts.length && t.every((seg, i) => (SEGMENT_PARAM.test(seg) ? FILLED_VALUE.test(parts[i]!) : seg === parts[i]));
  });
  hits.sort((a, b) => (a.match(/:/g)?.length ?? 0) - (b.match(/:/g)?.length ?? 0));
  return hits[0];
}
